import React from 'react';
import { useSelector } from 'react-redux';

import {
  Image, WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  CoreLink,
} from '@uncinc/react-drupal-core';

import './style.scss';

const DefaultItem = ({ item, showImage = true, lazyload = true }) => {
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));
  const uuid = item.getIn(['uuid', 0, 'value'], '');
  const title = item.getIn(['entity', 'field_title', 0, 'value'], item.getIn(['name', 0, 'value'], ''));
  const text = item.getIn(['entity', 'field_text', 0, 'processed'], item.getIn(['field_body', 0, 'processed'], ''));
  const image = item.getIn(['entity', 'field_image', 0, 'styles', 'cropped_10_7'], item.getIn(['field_image', 0, 'styles', 'cropped_10_7'], null));

  const url = item.getIn(
    ['entity', 'field_link', 0, 'alias'],
    item.getIn(['entity', 'field_link', 0, 'uri'],
      item.getIn(['paths', currentLanguage])),
  );

  return (
    <div key={uuid} className="Slider__item">
      <CoreLink to={url}>
        <div className="Slider__item__image">
          {image && (
            <Image
              lazyload={false}
              includeWebP
              src={image}
            />
          )}
        </div>
        <div className="Slider__item__title">
          <div className="Slider__item__title__content">
            <h3 className="asH2">{title}</h3>
            <i className="icon icon-arrow-right-filled icon-variant-4" />
          </div>
        </div>
        <div className={`Slider__item__content ${!showImage && 'active'}`}>
          <div className="inner">
            <h4 className="asH2">{title}</h4>
            {text && (
              <div className="truncate">
                <WysiwygField
                  property="schema:text"
                  html={text} />
              </div>
            )}
            <i className="icon icon-arrow-right-filled icon-variant-2" />
          </div>
        </div>
      </CoreLink>
    </div>
  );
};

export default DefaultItem;
